// +----------------------------------------------------------------------
// | 事后反馈选择：🤩 超出预期 / 😊 挺满意 / 😐 一般 / 😕 有点后悔
// | satisfaction: 5 / 4 / 3 / 2（后端 1~5）
// +----------------------------------------------------------------------
import './SatisfactionPicker.less';

export const SATISFACTION_OPTIONS = [
  { value: 5, emoji: '🤩', label: '超出预期' },
  { value: 4, emoji: '😊', label: '挺满意' },
  { value: 3, emoji: '😐', label: '一般' },
  { value: 2, emoji: '😕', label: '有点后悔' },
];

export function satisfactionLabel(value) {
  const item = SATISFACTION_OPTIONS.find((it) => it.value === Number(value));
  return item ? `${item.emoji} ${item.label}` : '';
}

export default function SatisfactionPicker({ value, onChange, disabled = false }) {
  return (
    <div className="satisfaction-picker">
      {SATISFACTION_OPTIONS.map((item) => (
        <button
          key={item.value}
          type="button"
          className={`satisfaction-item ${Number(value) === item.value ? 'is-active' : ''}`}
          onClick={() => !disabled && onChange(item.value)}
          disabled={disabled}
        >
          <span className="satisfaction-emoji">{item.emoji}</span>
          <span className="satisfaction-label">{item.label}</span>
        </button>
      ))}
    </div>
  );
}
